import React from 'react';
import { Link } from 'react-router-dom';
import { INROUTES } from '../../common/links';

import Footer from './../../components/skytone/Footer';

const Menu = () => {
    return (
        <nav id="nav">
            <ul className="menu wrap">
                <li><Link to={INROUTES.SKYTONE_ABOUT} name="page" value="About"><span className="no">00</span><span className="name">소개</span></Link></li>
                <li><Link to={INROUTES.SKYTONE_MODULE} name="page" value="Module"><span className="no">01</span><span className="name">모듈 조립</span></Link></li>
                <li><Link to={INROUTES.SKYTONE_FRAME} name="page" value="Frame"><span className="no">02</span><span className="name">프레임 조립</span></Link></li>
                <li><Link to={INROUTES.SKYTONE_WIFI} name="page" value="Wifi"><span className="no">03</span><span className="name">Wi-Fi 설정</span></Link></li>
                <li><Link to={INROUTES.SKYTONE_SETTING} value="Setting"><span className="no">04</span><span className="name">기능 설정</span></Link></li>
                <li><Link to={INROUTES.SKYTONE_FAQ} value="Faq"><span className="no">05</span><span className="name">FAQ</span></Link></li>
                <li><Link to={INROUTES.FINDMYDEVICE} target="_blank" rel="noreferrer" ><span className="no">#</span><span className="name">디바이스 주소 찾기</span></Link></li>
            </ul>
            <Footer />
        </nav>
    );
};

export default Menu;